<template>
  <div>
    <h3 class="title mb-3 green--text">Beneficiário</h3>
    <p>
      <strong>Número do cartão: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.beneficiarioCartaoDigito : "" }}
    </p>
    <p>
      <strong>Nome Completo: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.pessoaNomeCompleto : "" }}
    </p>
    <p>
      <strong>Situação: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.beneficiarioSituacao : "" }}
    </p>
    <p>
      <strong>Data de Nascimento: </strong
      >{{
        beneficiarioPinss
          ? beneficiarioPinss.pessoaDataNascimento
          : "" | formatDate
      }}
    </p>
    <p>
      <strong>Inicio de Vigência: </strong
      >{{
        beneficiarioPinss
          ? beneficiarioPinss.beneficiarioInicioVigencia
          : "" | formatDate
      }}
    </p>
    <p>
      <strong>Número CNS: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.numeroCns : "" }}
    </p>
    <p>
      <strong>CPT: </strong>{{ beneficiarioPinss ? beneficiarioPinss.cpt : "" }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Beneficiario",
  props: {
    beneficiarioPinss: Object
  }
};
</script>

<style scoped lang="scss">
.pinss {
  p {
    margin-bottom: 8px;
  }
}
</style>
